const ROUTES = {
    LANDING: "/",
    QUALIFYING: "/qualifying",
    DNF: "/did-not-finish",
};
export default ROUTES;
